var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.064 0H255.936C114.784 0 0 114.816 0 256C0 312 18.048 363.904 48.736 406.048L16.832 501.152L115.232 469.696C155.712 496.512 204 512 256.064 512C397.216 512 512 397.152 512 256C512 114.848 397.216 0 256.064 0Z",
    fill: "#31F168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.024 361.504C398.848 378.944 374.336 393.408 354.784 397.632C341.408 400.48 323.936 402.752 265.12 378.368C189.888 347.2 141.44 270.752 137.664 265.792C134.048 260.832 107.264 225.312 107.264 188.576C107.264 151.84 125.92 133.952 133.44 126.272C139.616 119.968 149.824 117.088 159.616 117.088C162.784 117.088 165.632 117.248 168.192 117.376C175.712 117.696 179.488 118.144 184.448 130.016C190.624 144.896 205.664 181.632 207.456 185.408C209.28 189.184 211.104 194.304 208.544 199.264C206.144 204.384 204.032 206.656 200.256 211.008C196.48 215.36 192.896 218.688 189.12 223.36C185.664 227.424 181.76 231.776 186.112 239.296C190.464 246.656 205.504 271.2 227.648 290.912C256.224 316.352 279.392 324.48 287.68 327.936C293.856 330.496 301.216 329.888 305.728 325.088C311.456 318.912 318.528 308.672 325.728 298.592C330.848 291.36 337.312 290.464 344.096 293.024C351.008 295.424 387.584 313.504 395.104 317.248C402.624 321.024 407.584 322.816 409.408 325.984C411.2 329.152 411.2 344.032 405.024 361.504Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.812e090c3a617f5018437b00acce39d1.svg";
export { ForwardRef as ReactComponent };